import React from 'react'
import { IconPhone, IconChat, IconMail, IconPhoneIncoming } from './icons'

function formatAge(dateStr) {
  if (!dateStr) return ''
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'now'
  if (mins < 60) return `${mins}m`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h`
  const days = Math.floor(hours / 24)
  return `${days}d`
}

export default function CommPanel({ commData, onOpenDrawer }) {
  const data = commData || {}
  const { unreadSms = [], voicemails = [], missedCalls = [], summary = {} } = data
  const total = summary.totalUnread || 0

  // Show top 2 items from any category as a preview
  const previewItems = [
    ...unreadSms.slice(0, 1).map(m => ({ icon: IconChat, label: m.fromName || m.from, sub: m.text?.substring(0, 40), age: m.receivedAt })),
    ...voicemails.slice(0, 1).map(vm => ({ icon: IconMail, label: vm.fromName || vm.from, sub: vm.transcription?.substring(0, 40) || 'Voicemail', age: vm.receivedAt })),
    ...missedCalls.slice(0, 1).map(c => ({ icon: IconPhoneIncoming, label: c.fromName || c.from, sub: 'Missed call', age: c.time })),
  ].slice(0, 3)

  return (
    <div className="panel comm-panel" onClick={onOpenDrawer} style={{ cursor: 'pointer' }}>
      <div className="panel-head">
        <h4>Communications</h4>
        <div className="right" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {total > 0 && (
            <span className="pill pill-warn" style={{ fontSize: '9.5px' }}>
              <span className="dot" />{total} unread
            </span>
          )}
          <IconPhone size={13} style={{ color: 'var(--ink-4)' }} />
        </div>
      </div>

      {previewItems.length > 0 ? (
        <div style={{ padding: '4px 6px 8px' }}>
          {previewItems.map((item, i) => {
            const Ic = item.icon
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px', fontSize: 12 }}>
                <Ic size={12} style={{ color: 'var(--ink-3)', flexShrink: 0 }} />
                <span style={{ fontWeight: 600, color: 'var(--ink-1)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 120 }}>{item.label}</span>
                <span style={{ color: 'var(--ink-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{item.sub}</span>
                <span style={{ color: 'var(--ink-4)', fontSize: 10.5, whiteSpace: 'nowrap' }}>{formatAge(item.age)}</span>
              </div>
            )
          })}
        </div>
      ) : (
        <div className="comm-empty">No recent communications</div>
      )}

      <div style={{ padding: '0 14px 10px', textAlign: 'center' }}>
        <span style={{ fontSize: 11, color: 'var(--brand, var(--primary))', fontWeight: 600 }}>
          Open Communications &rarr;
        </span>
      </div>
    </div>
  )
}
